"use strict";

export default class GMap {
	
	constructor(domID, centerPos, zoom) {
		const mapHolder = document.getElementById(domID);
		if(! mapHolder) {
			throw new Error('Gmap: Missing dom element');
		}
		
		if(! zoom) {
			zoom = 11;
		}
		
		this.markers = [];
		this.infoWindow = null;
		
		this.icon = {
			url: mapIcon.src,
			size: new google.maps.Size(mapIcon.width, mapIcon.height),
			origin: new google.maps.Point(0,0),
			anchor: new google.maps.Point(mapIcon.width * .5, mapIcon.height),
			scaledSize: new google.maps.Size(mapIcon.width * .5, mapIcon.height * .5)
		};
		
		
		this.map = new google.maps.Map(mapHolder, {
			zoom: zoom,
			center: new google.maps.LatLng(centerPos.latitude, centerPos.longitude),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
	
			streetViewControl: true,
			streetViewControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT
			},
			fullscreenControl: false,
			mapTypeControl: false,
			panControl: false,
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT
			},
			scaleControl: false,
			gestureHandling: 'cooperative'
		});
		
		
		
		google.maps.event.addListener(this.map, 'zoom_changed', this.resize.bind(this));
		google.maps.event.addListener(this.map, 'dragend', this.resize.bind(this));
	}
	
	
	setStyles(objectStyles) {
		this.map.setOptions({styles: objectStyles});
	}
	
	setCenter(coords) {
		this.map.setCenter(coords);
	}
	
	addMarkers(data) {
		if(! data.length)
			return;
			
		for(let i = 0; i < data.length; i++)
			this.addMarker(data[i]);
	}
	addMarker(data) {
		const _this = this;
		
		var marker = new google.maps.Marker({
						position: new google.maps.LatLng(data.latitude, data.longitude),
						map: this.map,
						title: data.name,
						icon: this.icon
					});
					
		marker.index = this.markers.length;
		
		marker.addListener('click', function() {
			var options = { content: data.info, position: this.position };
			
			if( _this.infowindow )
				_this.infowindow.close();
				
			_this.infowindow = new google.maps.InfoWindow(options);
			_this.infowindow.open(_this.map);
			//document.location.href = this.permalink; 
		});
	
		this.markers.push(marker);
	};
	
	
	setMarkersOnMap() {
		for(let i = 0; i < this.markers.length; i++)
			this.markers[i].setMap(this.map);
        
	};
	
	showMarkers() {
		this.setMarkersOnMap();	
	};
	
	clearMarkers() {
		this.setMarkersOnMap(null);	
		if( this.infowindow )
			this.infowindow.close();
	};
	
	deleteMarkers() {
		this.clearMarkers();
		this.markers = [];
	};
	
	resize() {
		for( let i = 0; i < this.markers.length; i++ ) {
			this.markers[i].setIcon(
				new google.maps.MarkerImage(
					this.icon.url,
					this.icon.size,
					this.icon.origin,
					this.icon.anchor,
					this.icon.scaledSize
				)
			);
		}
	};
}


// https://snazzymaps.com/editor/customize/8097
const googleMapStyles = [
    {
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "weight": "2.00"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#9c9c9c"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#7b7b7b"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#46bcec"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#c8d7d4"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#070707"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    }
];

